<template>
  <div class="gallery-container" dir="rtl">
    <div class="gallery-card">
      <div class="images-list">
        <div v-for="img in images" :key="img.name" class="image-item">
          <img :src="img.src" :alt="img.name" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InsureRule",
  data() {
    return {
      images: [],
    };
  },
  created() {
    const requireContext = require.context("../img/insureImg", false, /\.png$/);
    const images = requireContext
      .keys()
      .sort((a, b) => a.localeCompare(b))
      .map((path) => ({
        src: requireContext(path),
        name: path.split("/").pop().replace(/^\.\//, ""),
      }));
    this.images = images;
  },
};
</script>

<style scoped>
.gallery-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background: #fff;
  font-family: "UKIJEkran", sans-serif;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 60px 10px;
  border-radius: 10px;
  margin: 10px;
  width: calc(100% - 20px);
}
.gallery-card {
  background: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  max-width: 100%;
  width: 100%;
  font-family: "UKIJEkran", sans-serif;
}
.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}
.desc {
  color: #444;
  font-size: 13px;
  margin-bottom: 18px;
  line-height: 1.7;
}
.images-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.image-item {
  display: block;
  background: none;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  margin: 0;
}
.image-item img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 0;
  margin: 0;
  background: none;
}
.img-name {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}

</style>
